import React, { useState } from 'react';

function SurveyStepTwelve({ formData, onNext }) {
    const [prescriptionAccuracy, setPrescriptionAccuracy] = useState(formData.prescriptionAccuracy || '');
    const [prescriptionComments, setPrescriptionComments] = useState(formData.prescriptionComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!prescriptionAccuracy) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ prescriptionAccuracy, prescriptionComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 3: Patient Safety & Service</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How well are prescriptions checked and dispensed in line with regulations? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`prescription-accuracy-${option}`}
                            name="prescriptionAccuracy"
                            value={option}
                            checked={prescriptionAccuracy === option}
                            onChange={() => setPrescriptionAccuracy(option)}
                        />
                        <label htmlFor={`prescription-accuracy-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={prescriptionComments}
                    onChange={(e) => setPrescriptionComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!prescriptionAccuracy}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwelve;
